<template>
    <Drawer
        ref="drawer"
        title="API授权"
        :value="value"
        :mask="false"
        width="420"
        @input="onInput"
    >
        <div class="raa-toolbar flex">
            <Input
                v-model="keyword"
                clearable
                placeholder="uri / title 搜索"
            ></Input>
            <Button
                :loading="loading"
                type="primary"
                style="margin-left: 10px"
                @click="onSave"
                >保存</Button
            >
        </div>
        <div class="raa-content">
            <Spin v-if="loading" fix size="large"></Spin>
            <!-- 搜索树 -->
            <Tree
                v-show="keyword"
                :data="filterList"
                :render="apiRender"
                show-checkbox
                @on-check-change="onFilterCheckChange"
            ></Tree>
            <!-- 完整树 -->
            <Tree
                ref="tree"
                v-show="!keyword"
                :data="treeData"
                :render="apiRender"
                show-checkbox
            ></Tree>
        </div>
    </Drawer>
</template>

<script>
import { apiAll, updateResourceApi, apiListByResource } from '@/api/sys-api'
import { Drawer } from 'ivux'
import { listToTree, debounce } from '_u/helper'
import Enum from '_u/enum'

const RES_TYPE = Enum.get('RESOURCE_TYPE')

export default {
    name: 'ResApiAuth',
    components: {
        Drawer,
    },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        resource: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            loading: false,
            keyword: '',
            apiList: [], // api列表
            authMap: {}, // 上一次已授权api
            filterList: [], //
        }
    },
    computed: {
        treeData() {
            var me = this

            return listToTree(this.apiList, {
                pId: 'pid',
                done(tree, map, list) {
                    list.forEach((v) => {
                        if (me.authMap[v.id]) {
                            me.$set(v, 'checked', true)
                        }
                    })
                },
            })
        },
    },
    watch: {
        value(val) {
            if (val) {
                this.runTask(this.fetch)
            }
        },
        resource(val) {
            if (val) {
                this.runTask(this.fetchResApi)
            }
        },
        keyword() {
            this.filterData()
        },
    },
    methods: {
        runTask(fn) {
            this.loading = true

            if (typeof fn === 'string') {
                fn = this[fn]
            }

            fn().finally(() => {
                this.loading = false
            })
        },

        fetch() {
            return Promise.all([this.fetchApiAll(), this.fetchResApi()])
        },

        fetchApiAll() {
            return apiAll().then((res) => {
                this.apiList = res ? res.data.data : []
            })
        },

        fetchResApi() {
            if (this.canAuth(this.resource)) {
                return apiListByResource(this.resource.id).then((res) => {
                    this.authMap = res
                        ? res.data.data.reduce((acc, v) => {
                              acc[v.apiId] = true

                              return acc
                          }, {})
                        : {}
                })
            } else {
                return Promise.resolve().then(() => {
                    this.authMap = {}
                })
            }
        },

        apiRender(h, { root, node, data }) {
            return (
                <div class="raa-item">
                    <div class="raa-item-uri">{data.uri}</div>
                    <div class="raa-item-desc">{data.description}</div>
                </div>
            )
        },

        canAuth() {
            return this.resource && this.resource.type === RES_TYPE.action
        },

        filterData: debounce(350, function () {
            var list = this.apiList,
                keyword = this.keyword

            if (keyword) {
                list = list.filter(
                    (v) =>
                        (v.uri && v.uri.indexOf(keyword) >= 0) ||
                        (v.description && v.description.indexOf(keyword) >= 0)
                )
            } else {
                return (this.filterList = [])
            }

            return (this.filterList = listToTree(list, {
                pId: 'pid',
                done(tree, map, list) {
                    list.forEach((v) => (v.expand = true))
                },
            }))
        }),

        onFilterCheckChange(checkeds, data) {
            var target = this.$refs.tree.flatState.find(
                (v) => v.node.id === data.id
            )

            // 同步变更到完整树
            this.$refs.tree.handleCheck({
                checked: data.checked,
                nodeKey: target.node.nodeKey,
            })
        },

        onInput(val) {
            this.$emit('input', val)
        },

        onSave() {
            this.loading = true

            return Promise.resolve()
                .then(() => {
                    if (this.canAuth() === false) {
                        return Promise.reject({
                            msg: '只有功能点才能授权',
                        })
                    }
                })
                .then(() => {
                    var t = this

                    var apiIds = this.$refs.tree
                        .getCheckedNodes()
                        .reduce((acc, v) => {
                            if (v.pid != '0') {
                                acc += `${v.id},`
                            }

                            return acc
                        }, '')

                    if (apiIds) {
                        apiIds = apiIds.slice(0, apiIds.length - 1)
                    }

                    // console.log(apiIds)
                    return updateResourceApi({
                        resourceId: this.resource.id,
                        apiIds,
                    })
                })
                .then(() => {
                    this.$Message.success('授权成功')
                })
                .catch((err) => {
                    if (err && err.msg) {
                        this.$Message.error(err.msg)
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
    },
}
</script>

<style lang="less">
.raa {
    &-toolbar {
        box-sizing: border-box;
        position: absolute;
        top: 8px;
        left: 16px;
        right: 16px;
        background-color: #fff;
    }

    &-content {
        box-sizing: border-box;
        position: absolute;
        top: 44px;
        left: 16px;
        right: 16px;
        bottom: 16px;
        overflow: auto;
    }

    &-item {
        padding-left: 10px;
    }
}
</style>
